<template>
  <cookie-law theme="dark-lime">
    <div slot="message">
      To make SanitizerWristbands.com work , we log user data. By using this website, you agree to our <router-link to="privacy-policy">Privacy Policy</router-link> including cookie policy
    </div>
  </cookie-law>
</template>
<script>
import CookieLaw from 'vue-cookie-law'
export default {
  components: { CookieLaw }
}
</script>



// WEBPACK FOOTER //
// src/components/CookieBanner.vue